module.exports = __webpack_public_path__ + "img/disabled-menu-icon.4018e038.svg";